import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useSearchStore } from '../../../../../src/store/search/SearchStore'
import BaseDrawer from '../../../../../src/ui-components/modals/BaseDrawer'
import styled from 'styled-components'
import ShowDiagramsButton from './ShowDiagramsButton'
import ShowSpecificationsButton from './ShowSpecificationsButton'
import { defaultTheme } from '../../../../../src/theme/index'
import { Button } from '../../../../../src/ui-components/forms/Button'
import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'

interface ExtraDetailsDrawerProps {
  showDiagrams: boolean
}

const ExtraDetailsDrawer = createNiceModal<ExtraDetailsDrawerProps>(
  observer(({ showDiagrams }): ReactElement => {
    const modal = useModal()
    const title = 'additionalDetails'
    const { currentVehicle } = useSearchStore()

    const showSpecifications =
      currentVehicle?.engine?.id && currentVehicle?.type?.id === 111

    const body = (
      <Wrapper>
        <DividerLine />
        {showSpecifications && (
          <>
            <ActionWrapper>
              <ShowSpecificationsButton />
            </ActionWrapper>
            <DividerLine />
          </>
        )}
        {showDiagrams && (
          <>
            <ActionWrapper>
              <ShowDiagramsButton />
            </ActionWrapper>
            <DividerLine />
          </>
        )}
      </Wrapper>
    )
    const footer = (
      <Button
        size="fullwidth"
        variant="secondary"
        text="close"
        onClick={() => modal.remove()}
      />
    )

    return (
      <BaseDrawer
        title={title}
        body={body}
        footer={footer}
        onClose={() => modal.remove()}
        open={modal.visible}
      />
    )
  })
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  margin-bottom: 5rem;
`

const ActionWrapper = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
`

const DividerLine = styled.div`
  width: 100%;
  border-top: 1px solid ${defaultTheme.colors.border};
`

export default ExtraDetailsDrawer
